import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { DiceService } from '../_services/dice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DICE_QUOTES_CONFIG } from '../../_common/product-config';
import { LobStatus, QuoteStatus, StatusCode, NewBusiness, LobCodes } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-confirm-rate',
  templateUrl: './confirm-rate.component.html',
  styleUrls: ['./confirm-rate.component.scss']
})
export class ConfirmRateComponent implements OnInit {
  private headerData: HeaderData;
  private loading: boolean = false;
  private quotemessages = DICE_QUOTES_CONFIG.QuoteMessages;
  private modalMessages = DICE_QUOTES_CONFIG.ModalMessages;
  private lobStatusEnum = LobStatus;
  private quoteStatusEnum = QuoteStatus;
  private lobCodes = LobCodes;
  private bindModelData: any;

  private bindRatekeys: any = {
    applicationId: '',
    quoteId: '',
    policyEffectiveDate: '',
    waiveTRIA: '',
    certifyWaiveTRIA: '',
    accountFein: '',
    workerOptions: null
  };

  private rateRepsonseData: any;

  private isQuoteUpdated: boolean = false;
  
  @ViewChild("confirmPriceModal", {static: true}) confirmPriceModal: TemplateRef<any>;

  constructor(private diceService: DiceService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.headerData = new HeaderData();
    this.setHeaderData();
    this.fetchRateData();
  }

  setHeaderData(details?: any){
    this.headerData.pageTitle = "Confirm Quoted Price";

    if(details){
      this.headerData.detailMenu = [{label: "Account", description: details.accountName}];
    }

    this.diceService.header = this.headerData;
  }

  /*** Gets Application Key and Quote ID from URL Route / State Params  ***/
  getBindQuoteKeys() {
    this.bindModelData = this.diceService.diceBindDetailsData;

    this.route.paramMap.subscribe(params => {
      this.bindRatekeys.applicationId = params.get('key').toString();
      this.bindRatekeys.quoteId = params.get("id").toString();

      console.log("bindRatekeys :: ", this.bindRatekeys);

    });

    console.log('this.bindModelData :: ', this.bindModelData);

    this.bindRatekeys.policyEffectiveDate = this.bindModelData.policyEffectiveDate;
    this.bindRatekeys.waiveTRIA = this.bindModelData.waiveTRIA;
    this.bindRatekeys.certifyWaiveTRIA = this.bindModelData.certifyWaiveTRIA;
    this.bindRatekeys.accountFein = this.bindModelData.accountFein;
    this.bindRatekeys.workerOptions = this.bindModelData.workerOptions;
  }

  /*** Fetch Lookup Reference Data to populate values on UI ***/
  fetchRateData() {
    this.getBindQuoteKeys();
    this.loading = true;
    this.diceService.openModal('none', this.confirmPriceModal, false, 'dark-blue-backdrop', 'static', 'dice-modal', '', true);

    let rateDataSubscription = this.diceService.fetchRequoteDataQueue(this.bindRatekeys).subscribe(taskId => {
      console.log("Polling TaskID :: ", taskId);

      /* Polling started */
      let pollingQueueRequestSubscription = this.diceService.queueTask(taskId).subscribe(queueResp => { 
        console.log("finally its successful! " + queueResp);
        this.diceService.closeModal();
        this.loading = false;
        this.rateRepsonseData = queueResp;
  
        console.log("rateRepsonseData :: ", this.rateRepsonseData);
        this.setHeaderData(this.rateRepsonseData);
        this.checkIfQuoteAmountDiffers();
        //this.setInitialFormData();
      },error=>{
        this.loading = false;
        console.log("opps!! got error after waiting long! " + error);
        this.diceService.closeModal();
        this.router.navigate(["/error"]);
      });

      this.diceService.runningServices.push(pollingQueueRequestSubscription);
      /* Polling ended */
      /* this.diceService.closeModal();
      this.loading = false;
      this.rateRepsonseData = response;

      console.log("rateRepsonseData :: ", this.rateRepsonseData);
      this.setHeaderData(this.rateRepsonseData);
      this.checkIfQuoteAmountDiffers();
      //this.setInitialFormData(); */
    }, error=>{
      this.loading = false;
      this.diceService.closeModal();
      
      if(error.status == StatusCode.InternalServer) {
        this.gotoUrl('/newbusiness');
      }
    });

    this.diceService.runningServices.push(rateDataSubscription);
  }

  checkIfQuoteAmountDiffers() {
    console.log(this.rateRepsonseData);
    console.log('this.isQuoteUpdated :: ', this.isQuoteUpdated);
    if(this.rateRepsonseData) {
      this.rateRepsonseData.lobsPremium.forEach(lob => {
        if(lob.lobStatus === this.lobStatusEnum.Quoted) {
          console.log(lob);
          if(lob.currentCommission !== lob.quoteCommission || lob.currentPremium !== lob.quotePremium || lob.currentTRIA !== lob.quoteTRIA || lob.currentTaxAndFees !== lob.quoteTaxAndFees || lob.currentTotal !== lob.quoteTotal || this.bindRatekeys.waiveTRIA) {
            this.isQuoteUpdated = true;
          }
        }
      });

      console.log('this.isQuoteUpdated :: ', this.isQuoteUpdated);
    }
  }

  gotoUrl(_url) {
    this.router.navigate([_url], {state: {selectedBusiness: NewBusiness.DICE}});
  }

  confirmRate() {
    console.log('Rates Confirmed');
    this.gotoUrl("newbusiness/dice/quoteissued/" + this.bindRatekeys.applicationId + "/" + this.bindRatekeys.quoteId);
  }

  ngOnDestroy() {
    this.diceService.runningServices.forEach(subscription => subscription.unsubscribe());
  }
}
